import React from "react";
import withStyles from "react-jss";
import classNames from "classnames";

const styles = (theme) => {
	return {
		root: {
			width: "100%",
			height: "100%",
			borderRadius: "10px",
			border: `solid 1px ${theme.palette.colors.lightGrayishViolet}`,
			position: "relative",
			zIndex: 0,
		},
		input: {
			width: "100%",
			height: "100%",
			border: "none",
			backgroundColor: theme.palette.colors.transparent,
			position: "relative",
			textAlign: "center",
			color: theme.palette.colors.darkSlateBlue,
			fontFamily: theme.fonts.medium,
			lineHeight: 1,
			fontSize: "16px",
		},
		button: {
			position: "absolute",
			top: 0,
			height: "100%",
			width: "50px",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			cursor: "pointer",
			color: theme.palette.colors.oneMoreGrey,
			fontSize: "24px",
			backgroundColor: theme.palette.colors.paleGrey,
			userSelect: "none",
			fontFamily: theme.fonts.light,
			lineHeight: "0.67",
		},
		minus: {
			left: 0,
			borderRadius: "10px 0 0 10px",
		},
		plus: {
			right: 0,
			borderRadius: "0 10px 10px 0",
		},
		[`@media (max-width: ${theme.media.sm})`]: {
			button: {
				width: "33.3%",
			},
		},
	};
};

class CounterButton extends React.Component {
	static defaultProps = {
		changeCallback: () => {},
	};

	constructor(props) {
		super(props);
		this.state = {
			value: 0,
		};
	}

	changeInput(event) {
		let value = parseInt(event.currentTarget.value) ? parseInt(event.currentTarget.value) : 0;
		this.setState({
			value: value,
		});
		this.props.changeCallback(value);
	}

	changeByOne(value) {
		let newValue = this.state.value + value;
		if (newValue >= 0) {
			this.setState({
				value: newValue,
			});
			this.props.changeCallback(newValue);
		}
	}

	render() {
		let classes = this.props.classes;
		return (
			<div className={classes.root}>
				<input
					type="tel"
					pattern="[0-9]*"
					className={classes.input}
					value={this.state.value}
					onChange={(event) => this.changeInput(event)}
				/>
				<div
					className={classNames(classes.button, classes.minus)}
					onClick={() => this.changeByOne(-1)}
				>
					{" "}
					–{" "}
				</div>
				<div
					className={classNames(classes.button, classes.plus)}
					onClick={() => this.changeByOne(1)}
				>
					{" "}
					+{" "}
				</div>
			</div>
		);
	}
}

export default withStyles(styles)(CounterButton);
